import React from 'react'

export const IconCirclePlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00006 1.75C4.996 1.75 1.75006 4.99594 1.75006 9C1.75006 13.0041 4.996 16.25 9.00006 16.25C13.0041 16.25 16.2501 13.0041 16.2501 9C16.2501 4.99594 13.0041 1.75 9.00006 1.75ZM0.250061 9C0.250061 4.16751 4.16757 0.25 9.00006 0.25C13.8326 0.25 17.7501 4.16751 17.7501 9C17.7501 13.8325 13.8326 17.75 9.00006 17.75C4.16757 17.75 0.250061 13.8325 0.250061 9ZM9.00006 5.25C9.41427 5.25 9.75006 5.58579 9.75006 6V8.25024H12C12.4142 8.25024 12.75 8.58603 12.75 9.00024C12.75 9.41446 12.4142 9.75024 12 9.75024H9.75006V12C9.75006 12.4142 9.41427 12.75 9.00006 12.75C8.58585 12.75 8.25006 12.4142 8.25006 12V9.75024H6C5.58579 9.75024 5.25 9.41446 5.25 9.00024C5.25 8.58603 5.58579 8.25024 6 8.25024H8.25006V6C8.25006 5.58579 8.58585 5.25 9.00006 5.25Z"
      fill="currentColor"
    />
  </svg>
)
